import { Component, OnInit, AfterViewInit } from '@angular/core';

import {
  trigger,
  state,
  style,
  animate,
  transition,
  stagger,
  query,
} from '@angular/animations';
import { AnalyticsService } from 'src/app/shared/services/analytics/analytics.service';

@Component({
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss'],
  animations: [
    trigger('bannerTrigger', [
      transition(':enter', [
        query('*', [
          style({ opacity: 0, transform: 'translateX(-50px)' }),
          stagger(50, [
            animate(
              '250ms cubic-bezier(0.35, 0, 0.25, 1)',
              style({ opacity: 1, transform: 'none' })
            ),
          ]),
        ]),
      ]),
    ]),
  ],
})
export class BannerComponent implements OnInit {
  yearsOfExperience = new Date().getFullYear() - 2019;

  constructor(public analyticsService: AnalyticsService) {}

  ngOnInit(): void {}

  interpolateYears(text: string): string {
    return text.replace(/\{\{\s*years\s*\}\}/g, String(this.yearsOfExperience));
  }

  downloadCV() {
    let url = window.location.href;

    // Open a new window with the CV
    window.open(url + '/../assets/cv/curriculum.pdf', '_blank');
  }
}
